import joi from 'joi';
import { AccessRuleAttributes } from '../../rule-api-client/types/rule.type';
import { CurrencyAttributes } from './currency';
import { DomainAttributes } from './domain';
import { LevelAttributes } from './level';
import { LevelsConfigAttributes } from './level-config';
import { ReferralConfigAttributes } from './referral';
import { SYSTEM_ISO_CODES } from '../../utils/system-languages';
import { SsoConfigAttributes } from './sso-config';
import { TemplateVersionAttributes } from '../../template-api-client/template.types';

export interface LoyaltyProgramEmbed {
  script: string;
  webview: string;
  iframe: string;
}

export interface AddProgramInput {
  name: string;
  languages: string[];
  externalRef?: string;
  publicName?: string;
  timezone?: string;
}

export const $programLanguages = joi
  .array()
  .min(1)
  .items(joi.string().valid(...SYSTEM_ISO_CODES));

export const $addProgramInput = joi.object({
  name: joi.string().required(),
  publicName: joi.string().optional().empty('').allow(null),
  externalRef: joi.string().optional().empty('').allow(null),
  languages: $programLanguages.required(),
  timezone: joi.string().optional().empty('').allow(null),
});

export interface UpdateProgramInput {
  name?: string;
  languages?: string[];
  ssoProxyClientId?: number | null;
}

export interface UpdateLoginConfigInput {
  ssoProxyClientId?: number;
}

export const $updateLoginAttributes = joi.object<UpdateLoginConfigInput>().keys({
  ssoProxyClientId: joi.number().optional(),
});

export interface ProgramAttributes {
  id: string;
  externalRef?: string;
  accountId: string;
  name: string;
  publicName?: string;
  languages: string[];
  templateId?: string | null;
  template?: TemplateVersionAttributes;
  currencies?: CurrencyAttributes[];
  domains?: DomainAttributes[];
  levels?: LevelAttributes[];
  levelConfig?: LevelsConfigAttributes;
  referralConfig?: ReferralConfigAttributes;
  accessRule?: AccessRuleAttributes;
  status?: ProgramStatus;
  ssoProxyClientId?: number | null;
  ssoConfig?: SsoConfigAttributes;
  timezone: string;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string;
}

export enum ProgramStatus {
  DELETING = 'DELETING',
  DELETING_ERROR = 'DELETING_ERROR',
  DELETED = 'DELETED',
  ARCHIVED = 'ARCHIVED',
}

export interface Language {
  isoCode: string;
  name: string;
}

export enum GetProgramIncludeOptions {
  currencies = 'currencies',
  domains = 'domains',
  levels = 'levels',
  levelConfig = 'levelConfig',
  referralConfig = 'referralConfig',
  ssoConfig = 'ssoConfig',
}
